import { ISelectOption } from '../models/filter-form.models';
import { AgeGroup, DayNight, Gender, Race, WeekDay } from '../models/filter.models';

export const weekDays: ISelectOption[] = [
  { value: WeekDay.MONDAY, viewValue: 'Monday' },
  { value: WeekDay.TUESDAY, viewValue: 'Tuesday' },
  { value: WeekDay.WEDNESDAY, viewValue: 'Wednesday' },
  { value: WeekDay.THURSDAY, viewValue: 'Thursday' },
  { value: WeekDay.FRIDAY, viewValue: 'Friday' },
  { value: WeekDay.SATURDAY, viewValue: 'Saturday' },
  { value: WeekDay.SUNDAY, viewValue: 'Sunday' },
];

export const dayNight: ISelectOption[] = [
  { value: DayNight.DAY, viewValue: 'Day time' },
  { value: DayNight.NIGHT, viewValue: 'Night time' },
];

export const months: ISelectOption[] = [
  { value: 'JANUARY', viewValue: 'January' },
  { value: 'FEBRUARY', viewValue: 'February' },
  { value: 'MARCH', viewValue: 'March' },
  { value: 'APRIL', viewValue: 'April' },
  { value: 'MAY', viewValue: 'May' },
  { value: 'JUNE', viewValue: 'June' },
  { value: 'JULY', viewValue: 'July' },
  { value: 'AUGUST', viewValue: 'August' },
  { value: 'SEPTEMBER', viewValue: 'September' },
  { value: 'OCTOBER', viewValue: 'October' },
  { value: 'NOVEMBER', viewValue: 'November' },
  { value: 'DECEMBER', viewValue: 'December' },
];

export const races: ISelectOption<Race>[] = [
  { value: Race.HISPANIC_LATINO, viewValue: 'Hispanic / Latino' },
  { value: Race.WHITE, viewValue: 'White' },
  { value: Race.BLACK, viewValue: 'Black' },
  {
    value: Race.ASIAN_PACIFIC_ISLANDER,
    viewValue: 'Asian / Pacific Islander',
  },
  {
    value: Race.ALASKA_AMERICAN,
    viewValue: 'Alaska Native / American Indian',
  },
];

export const gender: ISelectOption<Gender>[] = [
  { value: Gender.MALE, viewValue: 'Male' },
  { value: Gender.FEMALE, viewValue: 'Female' },
];

export const ageGroup: ISelectOption<AgeGroup>[] = [
  { value: AgeGroup.ADULT, viewValue: 'Adult' },
  { value: AgeGroup.MINOR, viewValue: 'Minor' },
];

export const csvColumns: Record<string, string> = {
  id: 'ID',
  month: 'MONTH',
  citationType: 'VIOLATION_NAME',
  offenceCode: 'VIOLATION_POLICE_CODE',
  date: 'DATE',
  time: 'DATE_TIME',
  dayNight: 'DAY_NIGHT',
  dayOfWeek: 'DAY_OF_WEEK',
  driverRace: 'DRIVER_RACE',
  driverSex: 'DRIVER_SEX',
  driverAgeGroup: 'DRIVER_AGE_GROUP',
  department: 'DEPARTMENT',
  zipCode: 'LOCATION_ZIP_CODE',
  city: 'LOCATION_CITY',
  state: 'STATE',
  vehicleYear: 'VEHICLE_YEAR',
  vehicleMake: 'VEHICLE_MAKE',
  vehicleModel: 'VEHICLE_MODEL',
  vehicleColor: 'VEHICLE_COLOR',
  vehicleType: 'VEHICLE_TYPE',
  vehicleLicPlate: 'VEHICLE_LIC_PLATE',
  phoneNumberCaptured: 'PHONE_NUMBER_CAPTURED',
  issueType: 'CITATION_TYPE',
};
